import { AccountModel, AddressModel } from "../api/models";
import { isCustodiedAccountType } from "./accounts";

export function isValidPartialAddress(address: AddressModel) {
  return Object.keys(address).some(
    (key) => !!address[key as keyof AddressModel],
  );
}

export function addressToString(address?: AddressModel | null) {
  if (!address) return;
  return `${address.address1}${
    address.address2 ? ", " + address.address2 : ""
  }, ${address.city}, ${address.region} ${address.postalCode}`;
}

export function getEmptyAddressObject(): AddressModel {
  return {
    id: null,
    address1: null,
    address2: null,
    city: null,
    country: null,
    createdAt: null,
    postalCode: null,
    postalCodeSuffix: null,
    location: null,
    updatedAt: null,
    region: null,
  };
}

export enum AddressType {
  Home = "Home Address",
  Mailing = "Mailing Address",
  Primary = "Primary Address",
  Other = "Other Address",
}

export const getAddressSelection = (
  account: AccountModel,
  otherAddress: AddressModel | null | undefined,
) => {
  let addresses: {
    key: AddressType;
    value: AddressModel | null | undefined;
  }[] = [];
  if (isCustodiedAccountType(account.accountType)) {
    return [
      {
        key: "Custodian Address",
        value: account.custodian?.address,
      },
    ];
  }
  if (account && account.accountType) {
    switch (account.accountType) {
      case "Individual":
        addresses = [
          {
            key: AddressType.Home,
            value: account.primaryAddress,
          },
          {
            key: AddressType.Mailing,
            value: account.mailingAddress,
          },
        ];

        break;
      case "Joint":
        addresses = [
          {
            key: AddressType.Home,
            value: account.individual1?.primaryAddress,
          },
          {
            key: AddressType.Mailing,
            value: account.individual1?.mailingAddress,
          },
        ];
        break;
      case "Entity":
      case "Trust":
        addresses = [
          {
            key: AddressType.Primary,
            value: account.primaryAddress,
          },
          { key: AddressType.Mailing, value: account.mailingAddress },
        ];
        break;
      default:
    }
    addresses.push({
      key: AddressType.Other,
      value: otherAddress || getEmptyAddressObject(),
    });
  }

  return addresses;
};
